import { useContext, useEffect } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const roles = ["Desenvolvedor", "Administrador", "Funcionario"];

export default function RequireRoles ({children, allowedRoles}) {
    const auth = useContext(AuthContext);
    const user = auth.getUser();
    let isRoleAllowed = false;
    
    if (!allowedRoles) 
        allowedRoles = roles;
    
    for (let i = 0; i < allowedRoles.length; i++) {
        if (allowedRoles[i] === user.funcao) {
            isRoleAllowed = true;
            break;
        }
    }

    return (
        <>
        {
            user && isRoleAllowed ? 
            children : null
        }
        </>
    );
}